export const SORT_SLUG = 's'
export const SORT_DESC_SLUG = 'desc'
